// 用户名格式正则
export const RegName = /^(?=[a-zA-Z0-9]{6,14}$)(?!.*[\W_]).*$/;
// 密码格式正则
export const RegPassword = /^(?=.{8,20}$)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?`~])[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?`~]+$/;
// 密码格式說明
export const RegPasswordTip = '• 长度需为 8 到 20 个字符\n• 须包含至少一个大写和小写字母\n• 须包含至少一个特殊符号（空格和英文句点除外）';
// 电话号码格式正则
export const RegPhone = /^[1-9]\d{10}$/;
// 电子邮箱格式正则
export const RegEmail = /^[A-Za-z0-9_]+[a-zA-Z0-9_\.\-]{0,}@\w+([-.]\w+)*\.\w+([-.]\w+)*/;